// extracted by mini-css-extract-plugin
var _1 = "ScrollSlider-moduleScrollSlider__aL5y9";
var _2 = "ScrollSlider-moduleScrollSliderContent__iqXiY";
var _3 = "ScrollSlider-modulegrabbing__vPqjr";
export { _1 as "ScrollSlider", _2 as "ScrollSliderContent", _3 as "grabbing" }
